export default "__VITE_ASSET__Doep9kK6__"